import GLightbox from "glightbox";

var lightboxInlineIframe = GLightbox({
    selector: ".glightbox",
});
